import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
    faRobot,
    faLaptopCode,
    faCode,
    faHeartbeat,
    faGraduationCap,
    faGamepad,
    faBullhorn,
    faBuilding,
    faChartLine,
    faGlobe,
    faPlaneDeparture,
    faTag,
    faBolt,
    faHandshake,
    faPalette,
    faShirt,
    faUsers,
    faTrophy,
    faStore,
    faMusic,
    faSackDollar,
} from '@fortawesome/free-solid-svg-icons';

// Best-effort icon per real niche tag seen in the data. Anything not listed
// here (a new niche the scraper starts turning up) falls back to a plain
// tag icon rather than breaking — this list is cosmetic, not a gate on
// which niches are usable.
const ICONS: Record<string, IconDefinition> = {
    ai: faRobot,
    software: faCode,
    technology: faLaptopCode,
    health: faHeartbeat,
    education: faGraduationCap,
    entertainment: faGamepad,
    marketing: faBullhorn,
    business: faBuilding,
    finance: faChartLine,
    lifestyle: faGlobe,
    travel: faPlaneDeparture,
    productivity: faBolt,
    affiliate: faHandshake,
    art: faPalette,
    fashion: faShirt,
    social: faUsers,
    sports: faTrophy,
    retail: faStore,
    music: faMusic,
    investing: faSackDollar,
};

export const getNicheIcon = (tag: string): IconDefinition => ICONS[tag.trim().toLowerCase()] || faTag;
